import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { OpacityLabelWrapper, BlockTextBase } from './MultiSelectFilterItem.style';
import { Checkbox, Box, Text, Flex, Icon } from '@qga/roo-ui/components';
import { filterUpdate } from 'store/search/searchActions';
import { mapEventValuesName } from './helper';

const MultiSelectFilterItem = ({ checked, type, onChange, name, count, displayPlusIcon, description, iconName, filterKey }) => {
  const isDisabled = count === 0 && !checked;
  const dispatch = useDispatch();

  const handleClick = () => {
    const mappedValues = mapEventValuesName(filterKey);
    const { groupName, itemName } = mappedValues;
    const action = filterUpdate({
      groupName: groupName,
      itemName: itemName,
      itemText: name,
      itemType: 'radio',
      itemValue: itemName === 'area' ? name : type,
    });

    dispatch(action);
  };

  return (
    <OpacityLabelWrapper key={type} name={type} isChecked={checked} data-disabled={isDisabled} onClick={handleClick}>
      <Checkbox name={type} checked={checked} onChange={onChange} disabled={isDisabled} />
      <Flex alignItems="center" justifyContent="space-between" width="100%">
        <Box>
          <Box>
            {iconName && <Icon name={iconName} size={[0, 22]} />}
            <Text fontSize="sm" ml={2}>
              {name}
            </Text>
          </Box>
          {description && (
            <BlockTextBase fontSize="xs" data-testid="description">
              {description}
            </BlockTextBase>
          )}
        </Box>
        <Box textAlign="right" width="30px">
          <Text color="greys.dusty" fontWeight="inherit" fontSize="sm">
            {displayPlusIcon && '+'}
            {count}
          </Text>
        </Box>
      </Flex>
    </OpacityLabelWrapper>
  );
};

MultiSelectFilterItem.propTypes = {
  checked: PropTypes.bool,
  type: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  count: PropTypes.number,
  displayPlusIcon: PropTypes.bool,
  hideCount: PropTypes.bool,
  description: PropTypes.string,
  iconName: PropTypes.string,
  filterKey: PropTypes.string.isRequired,
};

MultiSelectFilterItem.defaultProps = {
  checked: false,
  displayPlusIcon: false,
  hideCount: false,
  count: null,
  description: null,
  iconName: null,
};

export default MultiSelectFilterItem;
